// --- ICON THEMES ---
const THEME_ANIMALS = ['🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮', '🐷', '🐸', '🐵', '🐔', '🐧', '🐦', '🐤', '🦆', '🦅', '🦉', '🦇', '🐺', '🐗', '🐴', '🦄', '🐝', '🐛', '🦋'];
const THEME_FOOD = ['🍔', '🍕', '🍟', '🌭', '🍿', '🧂', '🥓', '🥚', '🧇', '🥞', '🍩', '🍪', '🍰', '🧁', '🥧', '🍫', '🍬', '🍭', '🥨', '🥐', '🍞', '🧀'];
const THEME_FRUITS = ['🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🫐', '🍈', '🍒', '🍑', '🥭', '🍍', '🥥', '🥝', '🍅', '🥑', '🍏'];
const THEME_VEGETABLES = ['🍆', '🥔', '🥕', '🌽', '🌶️', '🥒', '🥬', '🥦', '🧄', '🧅', '🍄', '🥜', '🫑', '🫛', '🫒', '🍠', '🫚'];
const THEME_PETS = ['🐶', '🐱', '🐭', '🐹', '🐰', '🦜', '🐠', '🐢', '🦎', '🐩', '🦔', '🐍', '🐸', '🦀', '🦂'];

const ICON_THEMES = [
    THEME_ANIMALS,    // Level 1
    THEME_FOOD,       // Level 2
    THEME_FRUITS,     // Level 3
    THEME_VEGETABLES, // Level 4
    THEME_PETS        // Level 5
];


// --- LEVEL LAYOUTS ---
// 0 = empty space, 1 = tile
// Each layout is designed to have an even number of tiles to be solvable.
const levelLayouts = [
    // Level 1: 6 rows, 7 columns (42 tiles)
    {
        rows: 6, cols: 7, shape: [
            [1, 1, 1, 1, 1, 1, 1],
            [1, 1, 1, 1, 1, 1, 1],
            [1, 1, 1, 1, 1, 1, 1],
            [1, 1, 1, 1, 1, 1, 1],
            [1, 1, 1, 1, 1, 1, 1],
            [1, 1, 1, 1, 1, 1, 1],
        ]
    },
    // Level 2: "reduce rows by one" -> 5 rows x 7 columns, one tile removed for even count (34 tiles)
    {
        rows: 5, cols: 7, shape: [
            [1, 1, 1, 1, 1, 1, 1],
            [1, 1, 1, 1, 1, 1, 1],
            [1, 1, 1, 1, 1, 1, 1],
            [1, 1, 1, 1, 1, 1, 1],
            [1, 1, 1, 0, 1, 1, 1],
        ]
    },
    // Level 3: "add in the new square row 3 only" -> Interpreted as 5x7 with 3rd row constricted (30 tiles)
    {
        rows: 5, cols: 7, shape: [
            [1, 1, 1, 1, 1, 1, 1],
            [1, 1, 1, 1, 1, 1, 1],
            [0, 0, 1, 1, 1, 0, 0],
            [1, 1, 1, 1, 1, 1, 1],
            [1, 1, 1, 0, 1, 1, 1],
        ]
    },
    // Level 4: "add another square" -> Added two tiles back to level 3 shape (32 tiles)
    {
        rows: 5, cols: 7, shape: [
            [1, 1, 1, 1, 1, 1, 1],
            [1, 1, 1, 1, 1, 1, 1],
            [0, 1, 1, 1, 1, 1, 0],
            [1, 1, 1, 1, 1, 1, 1],
            [1, 1, 1, 0, 1, 1, 1],
        ]
    },
    // Level 5: "reduce squares from first row" -> Removed two tiles from level 4's first row (30 tiles)
    {
       rows: 5, cols: 7, shape: [
            [0, 1, 1, 1, 1, 1, 0],
            [1, 1, 1, 1, 1, 1, 1],
            [0, 1, 1, 1, 1, 1, 0],
            [1, 1, 1, 1, 1, 1, 1],
            [1, 1, 1, 0, 1, 1, 1],
        ]
    }
];


// --- DOM ELEMENTS ---
const gameBoardEl = document.getElementById('game-board') as HTMLDivElement;
const effectsContainerEl = document.getElementById('effects-container') as HTMLDivElement;
const scoreDisplayEl = document.getElementById('score-display') as HTMLSpanElement;
const timeDisplayEl = document.getElementById('time-display') as HTMLSpanElement;
const levelDisplayEl = document.getElementById('level-display') as HTMLSpanElement;
const restartButton = document.getElementById('restart-button') as HTMLButtonElement;
const shuffleButton = document.getElementById('shuffle-button') as HTMLButtonElement;
const hintButton = document.getElementById('hint-button') as HTMLButtonElement;
const playAgainButton = document.getElementById('play-again-button') as HTMLButtonElement;
const winModalEl = document.getElementById('win-modal') as HTMLDivElement;
const finalScoreEl = document.getElementById('final-score') as HTMLSpanElement;
const finalTimeEl = document.getElementById('final-time') as HTMLSpanElement;
const root = document.documentElement;

// --- GAME STATE ---
let board: (string | null)[][] = [];
let selectedTile: { row: number; col: number; el: HTMLDivElement } | null = null;
let score = 0;
let tilesRemaining = 0;
let timerInterval: ReturnType<typeof setInterval> | null = null;
let secondsElapsed = 0;
let shufflesRemaining = 3;
let hintsRemaining = 3;
let hintedTiles: {el: HTMLDivElement}[] | null = null;
let isShuffling = false;
let isAnimatingMatch = false;
let isGameActive = false;
let level = 1;
let currentBoardRows: number;
let currentBoardCols: number;
// These will be dynamically calculated after render for perfect accuracy
let TILE_WIDTH = 50;
let TILE_HEIGHT = 50;
let TILE_GAP = 5;
let tileElementMap: Map<string, HTMLDivElement> = new Map();

// --- AUDIO ---
let audioCtx: AudioContext | null = null;

/**
 * Initializes the AudioContext on the first user interaction to comply with browser policies.
 */
function initAudio() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
  }
}

/**
 * Generic function to play a sound using the Web Audio API.
 * @param type The oscillator type.
 * @param frequency The frequency of the sound in Hz.
 * @param duration The duration of the sound in seconds.
 * @param volume The volume (0 to 1).
 */
function playSound(type: OscillatorType, frequency: number, duration: number, volume = 0.5) {
  if (!audioCtx) return;

  const oscillator = audioCtx.createOscillator();
  const gainNode = audioCtx.createGain();

  oscillator.type = type;
  oscillator.frequency.setValueAtTime(frequency, audioCtx.currentTime);

  gainNode.gain.setValueAtTime(volume, audioCtx.currentTime);
  gainNode.gain.exponentialRampToValueAtTime(0.00001, audioCtx.currentTime + duration);

  oscillator.connect(gainNode);
  gainNode.connect(audioCtx.destination);

  oscillator.start(audioCtx.currentTime);
  oscillator.stop(audioCtx.currentTime + duration);
}

// --- Sound Effect Functions ---
const playSelectSound = () => playSound('triangle', 440, 0.05, 0.3);
const playErrorSound = () => playSound('sawtooth', 150, 0.1, 0.2);

function playMatchSound() {
  if (!audioCtx) return;
  playSound('sine', 523.25, 0.1, 0.4); // C5
  setTimeout(() => playSound('sine', 783.99, 0.15, 0.4), 100); // G5
}

function playWinSound() {
  if (!audioCtx) return;
  playSound('sine', 523.25, 0.1, 0.4); // C5
  setTimeout(() => playSound('sine', 659.25, 0.1, 0.4), 120); // E5
  setTimeout(() => playSound('sine', 783.99, 0.1, 0.4), 240); // G5
  setTimeout(() => playSound('sine', 1046.50, 0.2, 0.5), 360); // C6
}


// --- GAME LOGIC ---

/**
 * Shuffles an array in place.
 * @param array The array to shuffle.
 */
function shuffleArray<T>(array: T[]): T[] {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

/**
 * Measures the rendered size of tiles and gaps for accurate effect placement.
 * This is crucial for responsive layouts where sizes are not fixed.
 * We defer this with setTimeout to ensure the browser has finished rendering the new layout.
 */
function updateTileMetrics() {
    setTimeout(() => {
        const firstTile = gameBoardEl.querySelector('.tile:not(.empty)') as HTMLDivElement;
        if (firstTile) {
            const rect = firstTile.getBoundingClientRect();
            TILE_WIDTH = rect.width;
            TILE_HEIGHT = rect.height;
            
            // Get gap from the grid container's computed style
            const boardStyle = getComputedStyle(gameBoardEl);
            TILE_GAP = parseFloat(boardStyle.gap) || 5;
        } else {
            // Fallback if the board is empty
             TILE_WIDTH = 40; TILE_HEIGHT = 40; TILE_GAP = 5;
        }
    }, 0);
}

/**
 * Initializes and starts a new game.
 */
function startGame() {
  // Get current level layout, looping if level exceeds defined layouts
  const layoutData = levelLayouts[(level - 1) % levelLayouts.length];
  currentBoardRows = layoutData.rows;
  currentBoardCols = layoutData.cols;
  const layoutShape = layoutData.shape;

  // Reset state
  score = 0;
  secondsElapsed = 0;
  selectedTile = null;
  shufflesRemaining = 3;
  hintsRemaining = 3;
  isShuffling = false;
  isAnimatingMatch = false;
  isGameActive = true;
  clearHint();
  updateShuffleButton();
  updateHintButton();
  updateScore(0);
  levelDisplayEl.textContent = String(level);
  stopTimer();
  startTimer();
  winModalEl.style.display = 'none';
  effectsContainerEl.innerHTML = '';
  
  // Set CSS variables for board dimensions
  root.style.setProperty('--board-cols', String(currentBoardCols + 2));
  root.style.setProperty('--board-rows', String(currentBoardRows + 2));

  // Calculate total tiles from the layout
  tilesRemaining = layoutShape.flat().filter(tile => tile === 1).length;

  // Select the icon theme for the current level
  const currentTheme = ICON_THEMES[(level - 1) % ICON_THEMES.length];

  // Generate tile pairs based on level difficulty and theme
  const numIconTypes = Math.min(currentTheme.length, 10 + Math.floor(level * 1.5));
  const tilePairs: string[] = [];
  const availableIcons = shuffleArray([...currentTheme]).slice(0, numIconTypes);
  
  for (let i = 0; i < tilesRemaining / 2; i++) {
    const icon = availableIcons[i % availableIcons.length];
    tilePairs.push(icon, icon);
  }
  shuffleArray(tilePairs);

  // Create the board data structure with a padding of nulls for easier pathfinding
  board = Array(currentBoardRows + 2).fill(null).map(() => Array(currentBoardCols + 2).fill(null));
  let pairIndex = 0;
  for (let r = 0; r < currentBoardRows; r++) {
    for (let c = 0; c < currentBoardCols; c++) {
      if(layoutShape[r][c] === 1) {
        board[r + 1][c + 1] = tilePairs[pairIndex++];
      }
    }
  }

  renderBoard();
  // Crucially, update metrics AFTER rendering the board and after a browser repaint cycle
  updateTileMetrics();
}

/**
 * Renders the game board in the DOM based on the current board state.
 */
function renderBoard() {
  gameBoardEl.innerHTML = '';
  tileElementMap.clear();
  for (let r = 0; r < currentBoardRows + 2; r++) {
    for (let c = 0; c < currentBoardCols + 2; c++) {
      const tileEl = document.createElement('div');
      tileEl.classList.add('tile');
      
      const icon = board[r][c];
      if (icon) {
        const tileInner = document.createElement('div');
        tileInner.classList.add('tile-inner');
        tileInner.textContent = icon;
        tileEl.appendChild(tileInner);
        tileEl.addEventListener('click', () => handleTileClick(r, c, tileEl));
        tileElementMap.set(`${r},${c}`, tileEl);
      } else {
        tileEl.classList.add('empty');
      }
      gameBoardEl.appendChild(tileEl);
    }
  }
}

/**
 * Handles clicks on a tile.
 * @param row The row of the clicked tile.
 * @param col The column of the clicked tile.
 * @param el The DOM element of the clicked tile.
 */
function handleTileClick(row: number, col: number, el: HTMLDivElement) {
  initAudio();
  clearHint();
  if (el.classList.contains('matched') || isShuffling || isAnimatingMatch || !isGameActive) return;

  if (!selectedTile) {
    selectedTile = { row, col, el };
    el.classList.add('selected');
    playSelectSound();
  } else {
    if (selectedTile.row === row && selectedTile.col === col) {
      selectedTile.el.classList.remove('selected');
      selectedTile = null;
      return;
    }

    isAnimatingMatch = true;
    const firstSelected = selectedTile;
    selectedTile = null;

    const iconsMatch = board[firstSelected.row][firstSelected.col] === board[row][col];
    const path = iconsMatch ? findPath({ row: firstSelected.row, col: firstSelected.col }, { row, col }) : null;

    if (path) {
      // --- Match found ---
      drawPath(path);
      
      setTimeout(() => {
        playMatchSound();
        firstSelected.el.classList.remove('selected');
        el.classList.remove('selected');
        firstSelected.el.classList.add('matched');
        el.classList.add('matched');
      }, 150);
      
      setTimeout(() => {
        firstSelected.el.classList.add('empty');
        el.classList.add('empty');
        firstSelected.el.innerHTML = '';
        el.innerHTML = '';

        board[firstSelected.row][firstSelected.col] = null;
        board[row][col] = null;
        
        updateScore(score + 100);
        tilesRemaining -= 2;
        if (tilesRemaining === 0) {
          handleWin();
        }
        isAnimatingMatch = false;
      }, 650); 
    } else {
      // --- No match ---
      playErrorSound();
      showInvalidMoveIndicator({row: firstSelected.row, col: firstSelected.col}, {row, col});
      
      firstSelected.el.classList.remove('selected');
      el.classList.add('selected'); // Briefly select the second tile for feedback
      
      setTimeout(() => {
          el.classList.remove('selected');
          isAnimatingMatch = false;
      }, 300);
    }
  }
}

/**
 * Finds a path between two points using BFS and returns the corner points of the path.
 * @returns An array of coordinates representing the path, or null if no path exists.
 */
function findPath(start: { row: number; col: number }, end: { row: number; col: number }): {row: number, col: number}[] | null {
  const directions = [ { dr: -1, dc: 0 }, { dr: 1, dc: 0 }, { dr: 0, dc: -1 }, { dr: 0, dc: 1 }];
  const queue: { row: number; col: number; turns: number; dirIndex: number, path: {row: number, col: number}[] }[] = [];
  const visited = new Set<string>();

  for(let i = 0; i < directions.length; i++) {
    queue.push({ ...start, turns: 0, dirIndex: i, path: [start] });
  }
  
  while (queue.length > 0) {
    const { row, col, turns, dirIndex, path } = queue.shift()!;
    const dir = directions[dirIndex];
    let nextRow = row + dir.dr;
    let nextCol = col + dir.dc;

    while (nextRow >= 0 && nextRow < currentBoardRows + 2 && nextCol >= 0 && nextCol < currentBoardCols + 2) {
      const posKey = `${nextRow},${nextCol},${dirIndex}`;
      if (visited.has(posKey)) break;
      
      if (nextRow === end.row && nextCol === end.col) {
        return [...path, end];
      }
      
      if (board[nextRow][nextCol] !== null) {
        break;
      }
      
      visited.add(posKey);

      if (turns < 2) {
        for (let newDirIndex = 0; newDirIndex < directions.length; newDirIndex++) {
          if (dirIndex !== newDirIndex && directions[dirIndex].dr !== -directions[newDirIndex].dr && directions[dirIndex].dc !== -directions[newDirIndex].dc) {
            const turnPoint = { row: nextRow, col: nextCol };
            queue.push({
              row: nextRow, col: nextCol, turns: turns + 1,
              dirIndex: newDirIndex, path: [...path, turnPoint]
            });
          }
        }
      }
      
      nextRow += dir.dr;
      nextCol += dir.dc;
    }
  }
  return null;
}

/**
 * Draws the connecting lines for a valid path.
 */
function drawPath(path: {row: number, col: number}[]) {
    for (let i = 0; i < path.length - 1; i++) {
        const p1 = path[i];
        const p2 = path[i+1];

        const lineEl = document.createElement('div');
        lineEl.className = 'path-line';

        const p1x = p1.col * (TILE_WIDTH + TILE_GAP) + TILE_WIDTH / 2;
        const p1y = p1.row * (TILE_HEIGHT + TILE_GAP) + TILE_HEIGHT / 2;
        const p2x = p2.col * (TILE_WIDTH + TILE_GAP) + TILE_WIDTH / 2;
        const p2y = p2.row * (TILE_HEIGHT + TILE_GAP) + TILE_HEIGHT / 2;

        const left = Math.min(p1x, p2x);
        const top = Math.min(p1y, p2y);
        const width = Math.abs(p1x - p2x);
        const height = Math.abs(p1y - p2y);
        const LINE_THICKNESS = 5;

        lineEl.style.left = `${left - LINE_THICKNESS / 2}px`;
        lineEl.style.top = `${top - LINE_THICKNESS / 2}px`;
        
        lineEl.style.width = `${Math.max(width, LINE_THICKNESS)}px`;
        lineEl.style.height = `${Math.max(height, LINE_THICKNESS)}px`;

        effectsContainerEl.appendChild(lineEl);
        setTimeout(() => lineEl.remove(), 400);
    }
}

/**
 * Shows a '❌' indicator for an invalid move.
 */
function showInvalidMoveIndicator(startTile: {row: number, col: number}, endTile: {row: number, col: number}) {
    const startX = startTile.col * (TILE_WIDTH + TILE_GAP) + TILE_WIDTH / 2;
    const startY = startTile.row * (TILE_HEIGHT + TILE_GAP) + TILE_HEIGHT / 2;
    const endX = endTile.col * (TILE_WIDTH + TILE_GAP) + TILE_WIDTH / 2;
    const endY = endTile.row * (TILE_HEIGHT + TILE_GAP) + TILE_HEIGHT / 2;

    const midX = (startX + endX) / 2;
    const midY = (startY + endY) / 2;

    const xEl = document.createElement('div');
    xEl.className = 'invalid-x';
    xEl.textContent = '❌';
    xEl.style.left = `${midX}px`;
    xEl.style.top = `${midY}px`;

    effectsContainerEl.appendChild(xEl);
    setTimeout(() => xEl.remove(), 500);
}


/**
 * Scans the board to find the first valid connectable pair.
 * @returns A tuple with the coordinates of the two tiles, or null if no pair exists.
 */
function findValidPair(): [{row: number, col: number}, {row: number, col: number}] | null {
    const iconMap = new Map<string, { row: number; col: number }[]>();

    for (let r = 1; r < currentBoardRows + 1; r++) {
        for (let c = 1; c < currentBoardCols + 1; c++) {
            const icon = board[r][c];
            if (icon) {
                if (!iconMap.has(icon)) iconMap.set(icon, []);
                iconMap.get(icon)!.push({ row: r, col: c });
            }
        }
    }

    for (const iconGroup of iconMap.values()) {
        if (iconGroup.length < 2) continue;
        for (let i = 0; i < iconGroup.length; i++) {
            for (let j = i + 1; j < iconGroup.length; j++) {
                const tileA = iconGroup[i];
                const tileB = iconGroup[j];
                if (findPath(tileA, tileB) !== null) {
                    return [tileA, tileB];
                }
            }
        }
    }
    return null;
}


/**
 * Shuffles the remaining tiles on the board with an animation.
 */
async function handleShuffle() {
  if (shufflesRemaining <= 0 || isShuffling || !isGameActive) return;

  isShuffling = true;
  shufflesRemaining--;
  updateShuffleButton();
  clearHint();

  const tilesToShuffle: { row: number; col: number; icon: string }[] = [];
  for (let r = 1; r < currentBoardRows + 1; r++) {
    for (let c = 1; c < currentBoardCols + 1; c++) {
      if (board[r][c]) {
        tilesToShuffle.push({ row: r, col: c, icon: board[r][c]! });
      }
    }
  }

  const icons = tilesToShuffle.map(t => t.icon);
  shuffleArray(icons);

  tilesToShuffle.forEach((tile, index) => {
    board[tile.row][tile.col] = icons[index];
  });
  
  tilesToShuffle.forEach(tile => {
    const el = tileElementMap.get(`${tile.row},${tile.col}`);
    el?.classList.add('shuffling');
  });

  await new Promise(resolve => setTimeout(resolve, 300));

  tilesToShuffle.forEach(tile => {
    const el = tileElementMap.get(`${tile.row},${tile.col}`);
    const tileInner = el?.querySelector('.tile-inner');
    if (tileInner) {
      tileInner.textContent = board[tile.row][tile.col];
    }
  });

  await new Promise(resolve => setTimeout(resolve, 300));

  tileElementMap.forEach(el => el.classList.remove('shuffling'));
  isShuffling = false;
}


// --- UI & TIMER ---

function updateShuffleButton() {
    shuffleButton.textContent = `Shuffle (${shufflesRemaining})`;
    shuffleButton.disabled = shufflesRemaining <= 0;
}

function updateHintButton() {
    hintButton.textContent = `Hint (${hintsRemaining})`;
    hintButton.disabled = hintsRemaining <= 0;
}

function clearHint() {
    if (hintedTiles) {
        hintedTiles.forEach(tile => tile.el.classList.remove('hint'));
        hintedTiles = null;
    }
}

function handleHint() {
    if (hintsRemaining <= 0 || isShuffling || isAnimatingMatch || !isGameActive) return;
    clearHint();
    const pair = findValidPair();
    if (pair) {
        hintsRemaining--;
        updateHintButton();
        const [tileA, tileB] = pair;
        const elA = tileElementMap.get(`${tileA.row},${tileA.col}`);
        const elB = tileElementMap.get(`${tileB.row},${tileB.col}`);
        if (elA && elB) {
            elA.classList.add('hint');
            elB.classList.add('hint');
            hintedTiles = [{ el: elA }, { el: elB }];
        }
    }
}

function updateScore(newScore: number) {
  score = newScore;
  scoreDisplayEl.textContent = String(score);
}

function formatTime(seconds: number): string {
    const mins = Math.floor(seconds / 60).toString().padStart(2, '0');
    const secs = (seconds % 60).toString().padStart(2, '0');
    return `${mins}:${secs}`;
}

function startTimer() {
    if (timerInterval) clearInterval(timerInterval);
    timeDisplayEl.textContent = formatTime(secondsElapsed);
    timerInterval = setInterval(() => {
        secondsElapsed++;
        timeDisplayEl.textContent = formatTime(secondsElapsed);
    }, 1000);
}

function stopTimer() {
    if (timerInterval) clearInterval(timerInterval);
    timerInterval = null;
}

function handleWin() {
    isGameActive = false;
    stopTimer();
    playWinSound();

    const centerRow = (currentBoardRows + 2) / 2;
    const centerCol = (currentBoardCols + 2) / 2;
    const maxDist = Math.sqrt(centerRow * centerRow + centerCol * centerCol);
    const animationDuration = 500; // Corresponds to CSS animation duration
    const maxDelay = 400; // Max delay for the ripple effect

    const allTiles = Array.from(gameBoardEl.children) as HTMLDivElement[];

    allTiles.forEach((tileEl, index) => {
        const r = Math.floor(index / (currentBoardCols + 2));
        const c = index % (currentBoardCols + 2);

        const dist = Math.sqrt(Math.pow(r - centerRow, 2) + Math.pow(c - centerCol, 2));
        const delay = (dist / maxDist) * maxDelay;

        setTimeout(() => {
            tileEl.classList.add('win-animation');
        }, delay);
    });

    // Show modal after the animation completes
    setTimeout(() => {
        finalScoreEl.textContent = String(score);
        finalTimeEl.textContent = formatTime(secondsElapsed);
        winModalEl.style.display = 'flex';
        // Clean up classes for next game
        allTiles.forEach(tileEl => tileEl.classList.remove('win-animation'));
    }, maxDelay + animationDuration);
}

// --- EVENT LISTENERS ---
restartButton.addEventListener('click', () => {
  initAudio();
  if (isGameActive) {
      if(confirm('Are you sure you want to start a new game? Your current progress will be lost.')) {
          level = 1;
          startGame();
      }
  } else {
      level = 1;
      startGame();
  }
});

playAgainButton.addEventListener('click', () => {
  initAudio();
  level++;
  startGame();
});

shuffleButton.addEventListener('click', () => {
  initAudio();
  handleShuffle();
});

hintButton.addEventListener('click', () => {
  initAudio();
  handleHint();
});


// --- INITIALIZE ---
startGame();